import { http } from '@/api/http'
import { find } from 'lodash'
import ActionCable from 'actioncable'

const channel = 'ChatChannel'
const subscriptionIdentifier = `{"channel":"${channel}"}`
const options = { received: received, disconnected: disconnected }
window.cable = window.cable || ActionCable.createConsumer()

// Just to have no undefined usage ;-)
let handleIncomingMessage = function() {}

function received(data) {
  if (data.message.text.trim().length === 0 && data.message.attachments.length === 0) return
  handleIncomingMessage(data)
}

function disconnected() {
  //  Not sure what logic (if any) should be here
}

window.subscriptionExists = window.subscriptionExists || function() {
  return find(
    window.cable.subscriptions.subscriptions,
    function(sub) { return sub.identifier === subscriptionIdentifier },
  )
}


export const chat = handleMessageFunction => {
  handleIncomingMessage = handleMessageFunction

  return {
    createSubscription: () => {
      return window.subscriptionExists() ? false : window.cable.subscriptions.create(channel, options)
    },

    removeSubscription: () => {
      const subscription = window.subscriptionExists()
      return subscription ? window.cable.subscriptions.remove(subscription) : false
    },

    unread: function() {
      return window.subscriptionExists() ? http.get('messages/unread') : false
    },

    createChannelConversation: (userIds, name) => {
      return window.subscriptionExists() ?
        http.get(
          'messages/new_channel_conversation',
          { params: { conversation: { user_ids: userIds, name: name } } },
        ) :
        false
    },

    createDirectMessageConversation: userIds => {
      return window.subscriptionExists() ?
        http.get(
          'messages/new_direct_message_conversation',
          { params: { conversation: { user_ids: userIds } } },
        ) :
        false
    },

    sendMessage: (conversationId, msgText, userIds) => {
      return window.subscriptionExists() ?
        http.post(
          'messages/create',
          { message: { recipient: conversationId, text: msgText }, conversation: { user_ids: userIds } },
        ) :
        false
    },

    uploadFile: (conversationId, file, userIds) => {
      return window.subscriptionExists() ?
        http.post(
          'messages/create',
          { message: { recipient: conversationId, attachment: file }, conversation: { user_ids: userIds } },
        ) :
        false
    },

    markAsRead: (conversationId, userIds) => {
      return window.subscriptionExists() ?
        http.post(
          'messages/mark_as_read',
          { message: { recipient: conversationId }, conversation: { user_ids: userIds } },
        ) :
        false
    },

    history: conversationId => {
      return window.subscriptionExists() ?
        http.get('messages/history', { params: { message: { recipient: conversationId } } }) :
        false
    },

    conversations: () => {
      return window.subscriptionExists() ?
        http.get('messages/conversations') :
        false
    },

    users: search => {
      return window.subscriptionExists() ?
        http.get('messages/users', { params: { search: search } }) :
        false
    },
  }
}
